export default {
  agreement: {
    listTitle: '协议列表',
    userAgreement: '用户使用协议',
    privacyAgreement: '用户隐私协议',
    cancellationAgreement: '用户注销协议',
    configured: '已配置',
    notConfigured: '未配置',
    effectiveChannels: '生效渠道',
    updateTime: '更新时间',
    updatedBy: '更新人',
    wechatMiniProgram: '微信小程序',
    alipayMiniProgram: '支付宝小程序',
    app: 'APP',
    content: '协议内容',
    contentRequired: '请输入协议内容',
    contentLimit: '协议内容不能超过 {count} 字',
    saveTip: '保存后，当前协议内容将在对应渠道的协议页面生效。',
    saveSuccess: '协议保存成功',
    unsavedTitle: '当前修改尚未保存',
    unsavedMessage: '切换协议或离开页面后，将丢失当前协议中未保存的修改。',
    continueEditing: '继续编辑',
    discardChanges: '放弃修改',
    empty: '暂无协议数据',
  },
};
